// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { ModuleType, Module, Chapter, Progress } from '../../../types/Model';
import { RootState } from '../../rootReducer';

export const iltCourseContentsRaw = (state: RootState) => state.iltCourseContentsDataReducer

/**
 * when fetching, set loading state
 */
export const makeIsFetchingIltCourseContentsData = (): Selector<RootState, boolean> => {
  return createSelector(
    iltCourseContentsRaw,
    (iltCourseContentsReducer) => iltCourseContentsReducer.isLoading
  );
};

/**
 * when error, set error state
 */
export const makeErrorIltCourseContentsData = (): Selector<RootState, any> => {
  return createSelector(
    iltCourseContentsRaw,
    (iltCourseContentsReducer) => iltCourseContentsReducer.error
  );
}

/**
 * when select specific content, return the content
 */
export const makeIltCourseContentsDataByIdSelector = (id: number): Selector<RootState, Chapter[]> => {
  return createSelector(
    iltCourseContentsRaw,
    (iltCourseContentsReducer) => {
      return iltCourseContentsReducer.iltCourseContents[id] || []
    }
  );
};

/**
 * select the progress data
 */
export const makeIltCourseContentsProgressByIdSelector = (id: number): Selector<RootState, Progress[]> => {
  return createSelector(
    iltCourseContentsRaw,
    (iltCourseContentsReducer) => iltCourseContentsReducer.iltCourseProgress[id]
  );
};

/**
 * when select specific content, return the content
 */
export const makeIltCourseDataById = (id: number) => {
  return createSelector(
    makeIltCourseContentsDataByIdSelector(id),
    (data: Chapter[]) => {
      const result = data.reduce((acc: Module[], cur) => {
        const newAry: Module[] = cur.modules.map((v) => {
          const theObj: any = {
            type: v.type
          };

          if (v.type === ModuleType.VIDEO) {
            theObj.vodId = v.vodId;
            theObj.videoUrls = v.videoUrls;
          } else if (v.type === ModuleType.LAB) {
            theObj.labId = v.labId;
          } else if (v.type === ModuleType.QUIZ) {
            theObj.quizId = v.quizId;
            theObj.examData = v.examData;
            theObj.answers = v.answers;
            theObj.explains = v.explains;
          }

          return theObj;
        });

        return acc.concat(newAry);
      }, []);

      return result;
    }
  );
};

/**
 * when select specific content, return the progress
 */
export const makeIltCourseProgressDataByIdSelector = (id: number): Selector<RootState, Progress[]> => {
  return createSelector(
    iltCourseContentsRaw,
    (iltCourseContentsReducer) => {
      return iltCourseContentsReducer.iltCourseProgress[id] || []
    }
  );
};
